import Image from 'next/image';
import { ButtonLink } from '@/components/ButtonLink';
import { MarkdownToJSX } from '@/components/MarkdownToJSX';
import type { BiscuitNavigationCardFragment } from '@/utils/dato/generated';

export const BiscuitNavigationCard = ({
  biscuitNavigationCardDescription,
  secondaryButtonLabel,
  secondaryButtonLink,
  primaryButtonLabel,
  primaryButtonLink,
  title,
}: BiscuitNavigationCardFragment) => (
  <div className="bg-background shadow-[0px_1px_#D4D7D9] bg-[url(/images/biscuit-silhouette.svg)] md:col-span-2 lg:col-span-1 lg:row-span-2 bg-no-repeat bg-position-[center_-220px] bg-size-[430px] text-center rounded-xl px-6 pb-6 pt-1">
    <div className="pl-6">
      <Image
        alt="Biscuit in a bowl with the Zopa debit card"
        src="/images/biscuits-in-bowl-square.png"
        className="mx-auto mb-6"
        height={200}
        width={200}
      />
    </div>
    <h2 className="text-2xl mb-3">{title}</h2>
    {biscuitNavigationCardDescription ? <MarkdownToJSX md={biscuitNavigationCardDescription} /> : null}
    <ButtonLink href={primaryButtonLink} className="mb-3 w-full">
      {primaryButtonLabel}
    </ButtonLink>
    {secondaryButtonLink ? (
      <ButtonLink href={secondaryButtonLink} variant="secondary" className="w-full" outline>
        {secondaryButtonLabel || 'Find out more'}
      </ButtonLink>
    ) : null}
  </div>
);
